<!--
    Displays the results of attempting to run one or more automations based on
    one or more automation triggers in the context of a specific project
-->
<template>
    <div>
        <div
            v-if="hasValidationErrors"
            class="mb-3">
            <h5>Validation Errors</h5>
            <template
                v-for="(model, i) in modelsWithErrors"
                v-bind:key="`error-list-${i}`">
                <failed-validation-list
                    v-bind:list-key="`error-list-${i}`"
                    v-bind:trigger-description="model.triggerDescription"
                    v-bind:failures="model.failedValidations" />
            </template>
        </div>
        <div
            v-if="showFollowUpActions"
            class="mb-3">
            <h5>Follow-up Actions</h5>
            <div v-if="hasValidationErrors">
                No configured follow-up actions will be taken since there are validation errors.
            </div>
            <div v-else>
                <template
                    v-for="(model, i) in modelsWithActions"
                    v-bind:key="`action-list-${i}`">
                    <potential-action-list
                        v-bind:list-key="`action-list-${i}`"
                        v-bind:trigger-description="model.triggerDescription"
                        v-bind:actions="model.potentialActions" />
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import failedValidationList from "./failedValidationList.vue";
    import potentialActionList from "./potentialActionList.vue";

    export default {
        components: {
            failedValidationList,
            potentialActionList
        },
        props: {
            /*
                An array of objects of the following form:
                {
                    triggerDescription: "Exiting the current status:",
                    automationPreview: AutomationPreview
                    failedValidations: [AutomationPreview.ValidationResult],
                    potentialActions: [AutomationPreview.PotentialAction]
                }
            */
            automationPreviewModels: { type: Array, required: false, default: () => [] },

            // Suppress the follow-up actions message if there are validation errors
            hideFollowUpOnError: { type: Boolean, required: false, default: false }
        },
        computed: {
            hasValidationErrors() {
                return this.automationPreviewModels.some((model) => {
                    return model.failedValidations && model.failedValidations.length > 0;
                });
            },
            hasPotentialActions() {
                return this.automationPreviewModels.some((model) => {
                    return model.potentialActions && model.potentialActions.length > 0;
                });
            },
            modelsWithErrors() {
                return this.automationPreviewModels.filter((model) => {
                    return this.modelHasErrors(model);
                });
            },
            modelsWithActions() {
                return this.automationPreviewModels.filter((model) => {
                    return this.modelHasActions(model);
                });
            },
            showFollowUpActions() {
                return this.hasPotentialActions && !(this.hideFollowUpOnError && this.hasValidationErrors);
            }
        },
        methods: {
            modelHasErrors(model) {
                return model.failedValidations && model.failedValidations.length > 0;
            },
            modelHasActions(model) {
                return model.potentialActions && model.potentialActions.length > 0;
            }
        }
    };
</script>
